module.exports = __webpack_public_path__ + "img/VentureWallet_android_whiteback.ae027db8.jpg";